export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_13_PowerSwitch_end.e45c6400.jpg";